import { calculateDecimal, filterData, log } from '../../utils/helpers'
import moment from 'moment'

export const InvoicesListingParamsPayload = (page, limit, filters, isList) => {
  log('ListingParamsPayload', page, limit, filters)

  let ListingParams = {
    'pageNo': !!isList ? 0 : page,
    'pageSize': !!isList ? 0 : limit
  }
  return {
    ...ListingParams, ...filterData({
      ...filters,
      'DocumentUUID': filters?.docUUID ?? null,
      'dateFrom': !!filters?.dateFrom ? moment(filters?.dateFrom).locale('en-us').format('YYYY-MM-DD') || '' : '',
      'dateTo': !!filters?.dateTo ? moment(filters?.dateTo).locale('en-us').format('YYYY-MM-DD') || '' : '',
      'submissionDateFrom': !!filters?.submissionDateFrom ? moment(filters?.submissionDateFrom).locale('en-us').format('YYYY-MM-DD') || '' : '',
      'submissionDateTo': !!filters?.submissionDateTo ? moment(filters?.submissionDateTo).locale('en-us').format('YYYY-MM-DD') || '' : ''
    })
  }
}

export const MsInvoicesListingParamsPayload = (continuationToken, limit, filters, isList) => {
  log('ListingParamsPayload', continuationToken, limit, filters)
  let ListingParams = {
    'continuationToken': !!continuationToken ? continuationToken : '',
    'pageSize': !!isList ? 0 : limit
    // 'submissionDateFrom':moment().subtract(1, 'months').utc().format(),
    // 'submissionDateTo':moment().utc().format()

  }
  // console.log('values output', filters )
  return {
    ...ListingParams,
    ...(filters.issueDateFrom || filters.issueDateTo
      ? {}
      : {
        'submissionDateFrom': moment().startOf('day').utc().subtract(1, 'months').locale('en-us').format(),
        'submissionDateTo': moment().endOf('day').locale('en-us').utc().format()
      }),
    ...filterData({
      ...filters,
      'issueDateFrom': !!filters?.issueDateFrom
        ? moment(filters?.issueDateFrom).startOf('day').locale('en-us').utc().format()
        : '',
      'issueDateTo': !!filters?.issueDateTo
        ? moment(filters?.issueDateTo).endOf('day').locale('en-us').utc().format()
        : '',
      'submissionDateFrom': !!filters?.submissionDateFrom
        ? moment(filters?.submissionDateFrom).startOf('day').locale('en-us').utc().format() :
        (!filters?.submissionDateFrom && !!filters?.submissionDateTo) ?
          moment(filters?.submissionDateTo).endOf('day').locale('en-us').utc().format()
          : '',
      'submissionDateTo': !!filters?.submissionDateTo
        ? moment(filters?.submissionDateTo).startOf('day').locale('en-us').utc().format() :
        (!filters?.submissionDateTo && !!filters?.submissionDateFrom) ?
          moment(filters?.submissionDateFrom).endOf('day').locale('en-us').utc().format()
          : ''
    })
  }
  // return { ...ListingParams, ...filterData(filters || {}) }
}


export const ListingParamsPayload = (entityName, page, limit, sort, filters, isList) => {
  log('ListingParamsPayload', entityName, page, limit, filters)
  let ListingParams = {
    sort: sort || '-created_at',
    'page': !!isList ? 0 : page,
    'perPage': !!isList ? 0 : limit
  }
  let newFilters = {}
  if (!!Object.keys(filters || {})?.length) {
    let likeKeys = ['name', 'email', 'title', 'mobile']
    Object.keys(filters).forEach((filterKey) => {
      if (!!likeKeys.includes(filterKey) && !!filters[filterKey]) {
        newFilters[`${filterKey}[like]`] = (filterKey === 'mobile') ? (filters[filterKey]?.length > 3 ? '%' + filters[filterKey]?.replace(/\s/g, '') + '%' || '' : '') : '%' + filters[filterKey] + '%'
      } else {
        newFilters[filterKey] = filters[filterKey]
      }
    })
  }
  return { ...ListingParams, ...filterData(newFilters || {}) }
}

export const InvoiceSignatureSubmitPayload = (currentInvoice, signature) => {
  let documents = { documents: [] }
  let submissionObject = currentInvoice
  if (!!signature && submissionObject?.documentTypeVersion?.toString() === '1.0') {
    submissionObject.signatures = [{
      signatureType: 'I',
      value: signature
    }]
  }
  documents.documents.push(submissionObject)
  return documents
}
export const InvoiceSubmitPayload = (invoiceData, invoiceSubType, hasReferences, objectOnly, isDraft) => {
  let documents = { documents: [] }
  // {
  //   "documents": [
  //   {
  //     "documentType": "I",
  //     "documentTypeVersion": "0.9",
  //     "dateTimeIssued": "2022-06-11T14:39:04Z",
  //     "internalID": "630361516284",
  //     "taxpayerActivityCode": "0472",
  //     "issuer": {
  //       "type": "B",
  //       "id": "628787103",
  //       "name": "اركديف ش ذ م م م",
  //       "address": {
  //         "branchID": "0",
  //         "country": "EG",
  //         "governate": "Ismailia",
  //         "regionCity": "Ismailia",
  //         "street": "وحده رقم6 بمبني مجمع خدمات المنطقه الحره بالاسماعيليه",
  //         "buildingNumber": "00000",
  //         "floor": null,
  //         "room": null,
  //         "landmark": null,
  //         "postalCode": "00000",
  //         "additionalInformation": " "
  //       }
  //     },
  //     "receiver": {
  //       "type": "F",
  //       "id": "10201020102",
  //       "name": "Arkdev 2",
  //       "address": {
  //         "country": "FR",
  //         "governate": "Cairo",
  //         "regionCity": "Nasr City",
  //         "street": "Ryada street",
  //         "buildingNumber": "5",
  //         "floor": "8",
  //         "room": "802",
  //         "landmark": "Gnena Mall",
  //         "postalCode": "12500",
  //         "additionalInformation": "Gnena Mall"
  //       }
  //     },
  //     "invoiceLines": [
  //       {
  //         "itemType": "GS1",
  //         "itemCode": "1000000000003",
  //         "description": "شاكوش صلب 2 ك",
  //         "internalCode": "pr-ar-124",
  //         "unitType": "KGM",
  //         "quantity": 3,
  //         "unitValue": {
  //           "currencySold": "EGP",
  //           "amountEGP": 185.5
  //         },
  //         "salesTotal": 556.5,
  //         "total": 691.16547,
  //         "valueDifference": 0,
  //         "totalTaxableFees": 53.9805,
  //         "netTotal": 539.805,
  //         "itemsDiscount": 0,
  //         "discount": {
  //           "rate": 3,
  //           "amount": 16.695
  //         },
  //         "taxableItems": [
  //           {
  //             "taxType": "T3",
  //             "amount": 12.5,
  //             "subType": "Tbl02",
  //             "rate": 0
  //           },
  //           {
  //             "taxType": "T7",
  //             "amount": 53.9805,
  //             "subType": "Ent01",
  //             "rate": 10
  //           },
  //           {
  //             "taxType": "T1",
  //             "amount": 84.87997,
  //             "subType": "V001",
  //             "rate": 14
  //           }
  //         ]
  //       },
  //       {
  //         "itemType": "GS1",
  //         "itemCode": "15000001230",
  //         "description": "Activ Logo Print Shorts Burgundy N50307421A 1 Piece",
  //         "internalCode": "pr-ar-126",
  //         "unitType": "KGM",
  //         "quantity": 1,
  //         "unitValue": {
  //           "currencySold": "EGP",
  //           "amountEGP": 255
  //         },
  //         "salesTotal": 255,
  //         "total": 287.793,
  //         "valueDifference": 0,
  //         "totalTaxableFees": 0,
  //         "netTotal": 252.45,
  //         "itemsDiscount": 0,
  //         "discount": {
  //           "rate": 1,
  //           "amount": 2.55
  //         },
  //         "taxableItems": [
  //           {
  //             "taxType": "T1",
  //             "amount": 35.343,
  //             "subType": "V001",
  //             "rate": 14
  //           }
  //         ]
  //       }
  //     ],
  //     "totalSalesAmount": 811.5,
  //     "totalDiscountAmount": 19.245,
  //     "netAmount": 792.255,
  //     "taxTotals": [
  //       {
  //         "taxType": "T3",
  //         "amount": 12.5
  //       },
  //       {
  //         "taxType": "T7",
  //         "amount": 53.9805
  //       },
  //       {
  //         "taxType": "T1",
  //         "amount": 120.22297
  //       }
  //     ],
  //     "extraDiscountAmount": 9.6512,
  //     "totalItemsDiscountAmount": 0,
  //     "totalAmount": 969.30727,
  //     "purchaseOrderReference": "Purchase Order Reference",
  //     "purchaseOrderDescription": "Purchase Order Description",
  //     "salesOrderReference": "Sales Order Reference",
  //     "salesOrderDescription": "Sales Order Description",
  //     "proformaInvoiceNumber": "Proforma Invoice Number",
  //     "payment": {
  //       "bankName": "Bank Name",
  //       "bankAddress": "Bank Address",
  //       "bankAccountNo": "Bank Account No",
  //       "bankAccountIBAN": "AB01 2345 6789 ABC123",
  //       "swiftCode": "ABCDEFAB123",
  //       "terms": "Payment Terms"
  //     },
  //     "delivery": {
  //       "approach": "Approach",
  //       "packaging": "Packaging",
  //       "dateValidity": "2022-06-10T17:05:10Z",
  //       "exportPort": "Export Port",
  //       "countryOfOrigin": null,
  //       "grossWeight": 150,
  //       "netWeight": 156,
  //       "terms": "Delivery Terms"
  //     }
  //   }
  // ]
  // }
  let fullSteps = {}
  if (invoiceSubType === 'full') {
    fullSteps = filterData({
      purchaseOrderReference: invoiceData?.step4?.purchaseOrderReference || null,
      purchaseOrderDescription: invoiceData?.step4?.purchaseOrderDescription || null,
      salesOrderReference: invoiceData?.step4?.salesOrderReference || null,
      salesOrderDescription: invoiceData?.step4?.salesOrderDescription || null,
      proformaInvoiceNumber: invoiceData?.step4?.proformaInvoiceNumber || null,
      payment: filterData({
        bankName: invoiceData?.step4?.bankName || null,
        bankAddress: invoiceData?.step4?.bankAddress || null,
        bankAccountNo: invoiceData?.step4?.bankAccountNo || null,
        bankAccountIBAN: invoiceData?.step4?.bankAccountIBAN || null,
        swiftCode: invoiceData?.step4?.swiftCode || null,
        terms: invoiceData?.step4?.paymentTerms || null
      }),
      delivery: filterData({
        approach: invoiceData?.step5?.approach || null,
        packaging: invoiceData?.step5?.packaging || null,
        dateValidity: invoiceData?.step5?.dateValidity ? moment(invoiceData?.step5?.dateValidity).locale('en-us').utc().format() : null,
        exportPort: invoiceData?.step5?.exportPort || null,
        countryOfOrigin: invoiceData?.step5?.countryOfOrigin || null,
        grossWeight: ![null, 0].includes(invoiceData?.step5?.grossWeight) ? parseFloat(invoiceData?.step5?.grossWeight) : null,
        netWeight: ![null, 0].includes(invoiceData?.step5?.netWeight) ? parseFloat(invoiceData?.step5?.netWeight) : null,
        terms: invoiceData?.step5?.deliveryTerms || null
      })
    })
  }
  let submissionObject = {
    documentType: invoiceData?.step1?.documentType || null,
    documentTypeVersion: invoiceData?.step1?.documentTypeVersion || null,
    dateTimeIssued: invoiceData?.step1?.dateTimeIssuedEdit ? moment(invoiceData?.step1?.dateTimeIssued).locale('en-us').utc().format() : moment().locale('en-us').utc().format(),
    internalID: invoiceData?.step1?.internalID?.toString() || null,
    serviceDeliveryDate: ['EI', 'EC', 'ED'].includes(invoiceData?.step1?.documentType)? (invoiceData?.step1?.serviceDeliveryDateEdit ? moment(invoiceData?.step1?.serviceDeliveryDate).locale('en-us').format('YYYY-MM-DD') : moment().locale('en-us').format('YYYY-MM-DD')) : (invoiceData?.step1?.serviceDeliveryDate ? moment(invoiceData?.step1?.serviceDeliveryDate).locale('en-us').format('YYYY-MM-DD') : null),
    taxpayerActivityCode: invoiceData?.step2?.taxpayerActivityCode || 'B',
    issuer: {
      type: invoiceData?.step2?.issuerType || 'B',
      id: invoiceData?.step2?.issuerID?.toString() || null,
      name: invoiceData?.step2?.issuerName || null,
      address: {
        branchID: invoiceData?.step2?.issuerBranchID?.toString() || null,
        country: invoiceData?.step2?.issuerAddress?.country || 'EG',
        governate: invoiceData?.step2?.issuerAddress?.governate || null,
        regionCity: invoiceData?.step2?.issuerAddress?.regionCity || null,
        street: invoiceData?.step2?.issuerAddress?.street || null,
        buildingNumber: invoiceData?.step2?.issuerAddress?.buildingNumber || null,
        floor: invoiceData?.step2?.issuerAddress?.floor || null,
        room: invoiceData?.step2?.issuerAddress?.room || null,
        landmark: invoiceData?.step2?.issuerAddress?.landmark || null,
        postalCode: invoiceData?.step2?.issuerAddress?.postalCode || null,
        additionalInformation: invoiceData?.step2?.issuerAddress?.additionalInformation || null
      }
    },
    receiver: {
      type: invoiceData?.step2?.receiverType || null,
      id: invoiceData?.step2?.receiverID?.toString() || (isDraft ? null : ''),
      name: invoiceData?.step2?.receiverName || null,
      address: {
        // branchID: invoiceData?.step2?.receiverBranchID?.toString() || '',
        country: invoiceData?.step2?.receiverAddress?.country || null,
        governate: invoiceData?.step2?.receiverAddress?.governate || null,
        regionCity: invoiceData?.step2?.receiverAddress?.regionCity || null,
        street: invoiceData?.step2?.receiverAddress?.street || null,
        buildingNumber: invoiceData?.step2?.receiverAddress?.buildingNumber || null,
        floor: invoiceData?.step2?.receiverAddress?.floor?.toString() || null,
        room: invoiceData?.step2?.receiverAddress?.room?.toString() || null,
        landmark: invoiceData?.step2?.receiverAddress?.landmark || null,
        postalCode: invoiceData?.step2?.receiverAddress?.postalCode || null,
        additionalInformation: invoiceData?.step2?.receiverAddress?.additionalInformation || null
      }
    },
    invoiceLines: getInvoiceLines(invoiceData?.step3?.invoiceLines?.filter(item => !item?.deleted), isDraft, invoiceData?.step1?.documentType),
    totalSalesAmount: !!invoiceData?.step3?.hasOwnProperty('calculatedTotalSalesAmountEGP') ? parseFloat(invoiceData?.step3?.calculatedTotalSalesAmountEGP) : parseFloat(invoiceData?.step3?.calculatedTotalSalesAmount),
    totalDiscountAmount: parseFloat(invoiceData?.step3?.totalDiscountAmount || 0),
    netAmount: parseFloat(!!invoiceData?.step3?.netAmountEdit ? invoiceData?.step3?.netAmount : (!!invoiceData?.step3?.hasOwnProperty('calculatedNetAmountEGP') ? invoiceData?.step3?.calculatedNetAmountEGP : invoiceData?.step3?.netAmount)),
    taxTotals: getInvoiceTaxTotals(invoiceData?.step3?.taxTotals),
    extraDiscountAmount: parseFloat(invoiceData?.step3?.extraDiscountAmount || 0),
    totalItemsDiscountAmount: parseFloat(!!invoiceData?.step3?.totalItemsDiscountAmountEdit ? invoiceData?.step3?.totalItemsDiscountAmount : (!!invoiceData?.step3?.hasOwnProperty('calculatedTotalItemsDiscountAmountEGP') ? invoiceData?.step3?.calculatedTotalItemsDiscountAmountEGP : invoiceData?.step3?.totalItemsDiscountAmount)),
    totalAmount: parseFloat(!!invoiceData?.step3?.totalAmountEdit ? invoiceData?.step3?.totalAmount : (!!invoiceData?.step3?.hasOwnProperty('calculatedTotalAmountEGP') ? invoiceData?.step3?.calculatedTotalAmountEGP : invoiceData?.step3?.totalAmount)),
    ...fullSteps
  }
  if (!!hasReferences) {
    submissionObject.references = invoiceData?.step1?.referencesList?.map(invoice => invoice.uuid || '')
  }
  // if (!!signature && !objectOnly && invoiceData?.step1?.documentTypeVersion?.toString() === '1.0') {
  //   submissionObject.signatures = [{
  //     signatureType: 'I',
  //     value: signature
  //   }]
  // }
  documents.documents.push(submissionObject)
  return !!objectOnly ? submissionObject : documents
}
const getInvoiceLines = (invoiceLines, isDraft, documentType) => {
  let data = []
  if (!!invoiceLines?.length) {
    invoiceLines.forEach(item => {
      let unitValue = {
        currencySold: item?.amountSold || null,
        amountEGP: parseFloat(calculateDecimal(item?.unitAmount * (item?.currencyRate?.rate || 1)))
      }
      if (item?.amountSold?.toString() !== 'EGP') {
        unitValue = {
          ...unitValue,
          amountSold: parseFloat(item?.unitAmount),
          currencyExchangeRate: parseFloat(item?.currencyRate?.rate)
        }
      }
      let line = {
        itemType: item?.itemType || null,
        itemCode: item?.itemCode || null,
        description: item?.description || null,
        internalCode: item?.internalCode || null,
        unitType: item?.unitType || null,
        quantity: parseFloat(item?.quantity),
        unitValue: unitValue,
        salesTotal: parseFloat(calculateDecimal((!!item?.salesTotalEdit ? item?.salesTotal : item?.calculatedSalesTotal) * (item?.currencyRate?.rate || 1))),
        total: parseFloat(calculateDecimal((!!item?.totalEdit ? item?.total : item?.calculatedTotal) * (item?.currencyRate?.rate || 1))),
        valueDifference: parseFloat(item?.valueDifference),
        totalTaxableFees: parseFloat(calculateDecimal((!!item?.totalTaxableFeesEdit ? item?.totalTaxableFees : item?.calculatedTotalTaxableFees) * (item?.currencyRate?.rate || 1))),
        netTotal: parseFloat(calculateDecimal((!!item?.netTotalEdit ? item?.netTotal : item?.calculatedNetTotal) * (item?.currencyRate?.rate || 1))),
        itemsDiscount: parseFloat(item?.itemsDiscount || 0),
        discount: {
          rate: parseFloat(item?.discountRate || 0),
          amount: parseFloat(calculateDecimal((!!item?.discountValueEdit ? item?.discountValue : item?.discountCalculatedValue) * (item?.currencyRate?.rate || 1)))
        },
        taxableItems: getTaxItems(item?.taxableItems, (item?.currencyRate?.rate || 1))
      }
      if (!!isDraft) {
        line.itemName = item?.itemName || null
      }
      if (!!['EI', 'EC', 'ED'].includes(documentType?.toUpperCase())) {
        line.weightUnitType = item?.weightUnitType || null
        line.weightQuantity = parseFloat(item?.weightQuantity || 0)
      }

      data.push(line)
    })
  }
  return data
}

const getTaxItems = (taxableItems, rate) => {
  let data = []
  if (!!taxableItems?.length) {
    taxableItems.forEach(item => {
      let tax = {
        taxType: item?.type || null,
        amount: parseFloat(calculateDecimal((!!item?.valueEdit ? item?.value : item?.calculatedValue) * rate)),
        subType: item?.subType || null,
        rate: !!item?.rate ? parseFloat(item?.rate) : 0
      }
      data.push(tax)
    })
  }
  return data
}

const getInvoiceTaxTotals = (taxTotals) => {
  let data = []
  if (!!taxTotals?.length) {
    taxTotals.forEach(item => {
      let tax = {
        taxType: item?.taxType || null,
        amount: parseFloat(!!item?.amountEdit ? item?.amount : item?.calculatedAmountEGP)
      }
      data.push(tax)
    })
  }
  return data
}

export const InvoiceActionPayload = (action, data) => {
  if (['cancel', 'reject'].includes(action)) {
    let returnedData = { ...data }
    if (returnedData['reason'] === 'otherReason') {
      returnedData['reason'] = returnedData['otherReason']
    }
    returnedData['otherReason'] = null
    return filterData(returnedData)
  }
  return data
}